module.exports = __webpack_public_path__ + "img/newCand-previewresume-icon.e06270c9.svg";